import * as React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { BallSpinner } from '@hotjar/webapp/components/BallSpinner';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100vh;
`;

const DemoAutoLoginWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const DemoLoginLoadingState = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <DemoAutoLoginWrapper data-testid="demo-container">
        <BallSpinner />
        <p data-testid="demo-notification">{t('common:login.demo-notification')}</p>
      </DemoAutoLoginWrapper>
    </Container>
  );
};
